__turbopack_context__.v({
  "arrow": "tooltip-module__URpj2W__arrow",
  "content": "tooltip-module__URpj2W__content",
  "tooltipIn": "tooltip-module__URpj2W__tooltipIn",
  "tooltipOut": "tooltip-module__URpj2W__tooltipOut",
});
